const CONFIG = {};
// -- URLS
CONFIG.baseNameUrl = process.env.REACT_APP_PORTAL_URL || '/portal';
CONFIG.authBaseUrl = process.env.REACT_APP_AUTH_URL || '/';
CONFIG.resourceBaseUrl = process.env.REACT_APP_RESOURCE_URL || '/';
CONFIG.apiBaseUrl =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_PROD_API_URL || '/gateway'
    : process.env.REACT_APP_DEV_API_URL || '/gateway';
CONFIG.fetchAllLimit = process.env.REACT_APP_FETCH_ALL_LIMIT || 1000;
// -- Login variables
CONFIG.title = process.env.REACT_APP_TITLE || 'Portail Coog';
CONFIG.subTitle = process.env.REACT_APP_SUBTITLE || "Assistant d'aide à la vente";
CONFIG.subTitleForgetPassword =
  process.env.REACT_APP_SUBTITLE_FORGET_PASSWORD || 'Création/Réinitialisation de votre mot de passe';
CONFIG.subTitleChangePassword = process.env.REACT_APP_SUBTITLE_CHANGE_PASSWORD || 'Changer votre mot de passe';
CONFIG.logoRef = process.env.REACT_APP_LOGO || 'https://coopengo.com/wp-content/uploads/2020/09/Coopengo_Logo_RVB.svg';
CONFIG.logoLink = process.env.REACT_APP_LOGO_LINK || 'http://www.coopengo.com/';
// -- System
CONFIG.menuDrawerSettings = {
  visible: process.env.REACT_APP_SYSTEM_MENU_VISIBLE ? process.env.REACT_APP_SYSTEM_MENU_VISIBLE === 'true' : true,
};
export default CONFIG;
